/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { NavCardsComponentEditor } from "cms/components/components/nav-cards/edit";
import { NavCardsComponentDisplay } from "cms/components/components/nav-cards/display";
import { getComponentZoneLayout } from "cms/components/components/component";

const NavCardsComponent = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <NavCardsComponentDisplay />,
        editComponent: <NavCardsComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

NavCardsComponent.displayName = "NavCardsComponent";
export { NavCardsComponent }; 
